<template>
  <div class="consultar-pedidos-expedidos">
    <g-card
      class="card-pedido-expedido"
      margem="20px"
      :expansivel="true"
      :comecaFechado="false"
    >
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Pedidos Expedidos / Faturados </div>
          <div class="header-icons">
            <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
              @click="limparFiltro"
            />
            <g-button
              class="buscar-button-header-filtro"
              largura="150px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="Buscar()"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form disabled>
        <div class="expedidos-faturados-conteudo espacamento-filtros">
          <div class="nome-produto">
            <div class="nome-produtoNovo-titulo titulo-conteudo-filtros"> Numero do Pedido </div>
            <PInputText
              class="numero-pedido-input input-label"
              placeholder="Insira o N° do pedido"
              v-model="formSearch.NumeroPedido"
            ></PInputText>
            </div>

          <div class="nome-produtoNovo">
            <div class="periodo-titulo titulo-conteudo-filtros"> No período entre </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                  class="periodo-inicio input-label"
                  placeholderinput="Início"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  invertido
                  :dataPassadas = "true"
                  v-model="formSearch.PeriodoInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                  class="periodo-termino input-label"
                  placeholderinput="Término"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  invertido
                  :dataPassadas = "true"
                  v-model="formSearch.PeriodoFim"
                ></g-date-input>
              </div>
            </div> 
          </div>

          <div class="cliente">
            <div class="codigo-produto-titulo titulo-conteudo-filtros"> Produto </div>
              <PDropDown
              class="nome-produto-input input-label"
              v-model="formSearch.NomeProduto"
              placeholder="Insira o nome do produto"
              optionLabel="labelProduto"
              optionValue="produtoId"
              @filter="getProduto($event.value)"
              :filter="true"
              :options="ProdutoArray"
              />
            </div>

            <div class="representante">
              <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <cliente-dropdown
              class="cliente-input input-label"
              v-model="formSearch.ClienteId"
              @change="ativaClienteAgrupador"
              :representanteId="this.$store.state.representanteSelecionadoId"
              :empresaId="formSearch.UnidadeId"
            />
            </div>

            <div class="unidade">
              <div class="unidade-titulo titulo-conteudo-filtros">Unidade</div>
              <PDropDown
                class="unidade-input input-label unidade"
                v-model="formSearch.UnidadeId"
                :filter="true"
                :options="EmpresaArray"
                optionLabel="nome"
                optionValue="id"
                placeholder="TODAS"
              ></PDropDown>
            </div>

          <div class="periodo">
                      <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>

            <div class="consultar-dados checkbox">
                <PCheckBox :disabled="ClienteAgrupadorAtiva" :binary="true" id="consultar-dados" value="consultar-dados" class="checkbox-consultas" v-model="formSearch.ConsultarDadosClienteAgrupador"></PCheckBox>
                <label class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
            </div>
          </div>

          <div class="parametros">
            <!-- <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div> -->
            <!-- <div class="consultar-dados checkbox">
                <PCheckBox :disabled="ClienteAgrupadorAtiva" :binary="true" id="consultar-dados" value="consultar-dados" class="checkbox-consultas" v-model="formSearch.ConsultarDadosClienteAgrupador"></PCheckBox>
                <label class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
            </div> -->
          </div>
        </div>
        <div class="buscar-button-filtro">
          <g-button
          class="buscar-button"
          largura="300px"
          icone="icone_lupa.svg"
          negritoTexto
          tamanhoIcone="15px"
          tamanhoTexto="15px"
          altura="35px"
          gap="10px"
          :sombreado="false"
          @click="Buscar()"
          >
          BUSCAR
          </g-button>
        </div>
      </g-form>
    </g-card>
    <!-- Card Nenhuma Informação -->
    <g-card :expansivel="false" :temCabecalho="false" class="card-resultado">
      <div v-if="pt1" class="">
        <img
          class="icone-global-imagemfundo"
          src="@/assets/imgs/Ilustracao_erro.svg"
        />
        <div class="texto-padrao-imagemfundo">
          Verifique os filtros e clique em buscar para exibir os resultados
        </div>
      </div>
      <div v-else-if="!pt1">
        <g-data-table
          TextoVazio="Nenhum Pedido Encontrado"
          Titulo="Pedidos"
          altura="auto"
          :colunas="Colunas"
          :valores="PedidosExpedidosFaturadosArray"
          :Paginacao="true"
          :NumeroLinhas="50"
          :numeroBotoesAcao="2"
          :FiltrosEspecificos="true"
          :Filtros="Filtro"
          :NotaFiscal="true"
          v-on:OnNotaFiscal="notasFiscaisRota"
          TextNotaFiscal="Nota Fiscal"
          v-on:duploClickLinha="detalhesPedido"
          :campoAgrupador="'empresaCliente'"
          :campoExibicaoGrupo="'empresaCliente'"
          :telaExpedidosFaturados = true
          :esconderColunaFrozen="true"
        >
        <template #groupfooter="slotProps">              
            <g-data-table
                :valores="[{}]"
                :ehSemDados="false"
                :ehReordenavel="false"
                :Paginacao = false
                :colunas="[
                        {header: ''},
                        {header: 'Total Expedidos/Faturados:'},
                        {header: ''},
                        {header: ''},
                        {header: ''},
                        {header: ''},
                        {header: slotProps.soma.valorFinalSomaQuantidadeExpedida.toLocaleString('pt-BR'), alinha:'flex-end'}
                ]"
                :esconderHeader="true"
                :esconderColunaFrozen="true"
            >
            </g-data-table>
        </template>
      </g-data-table>
      </div>
    </g-card>
  </div>
</template>

<script>
import ExpedidosFaturados from "./ExpedidosFaturados.js";
export default ExpedidosFaturados;
</script>

<style scoped>

:deep(.p-inputtext){
  width: 100%;
}
.input-label{
  margin-bottom: 15px;
}
.codigo-nome-produto {
  width: 100%;
}
.checkbox {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}
.label-checkbox {
  color: #8A8A8A;
  text-align: left;
  font-size: 15px;
  font-family: 'MontSerrat';
  margin-left: 5px;
}
td, th {
  border: 1px solid #e6e6e6;
  text-align: center;
  padding: 10px 40px;
}

@media (min-width: 310px) {
  .buscar-button-filtro {
    display: flex;
    justify-content: center;
    align-items: self-end;
  }
  .expedidos-faturados-conteudo {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
  }
  .codigo-nome-produto {
    display: grid;
    grid-template-columns: 30% auto;
    grid-template-rows: auto;
    grid-column-gap: 20px;
    align-items: flex-end;
  }
  .periodo-inicio { grid-area: 1 / 1 / 2 / 2; }
  .periodo-termino { grid-area: 1 / 3 / 2 / 4; }
  .input-label {
    width: 100%;
  }
}

@media (min-width: 368px) {
}

@media (min-width: 600px) {
  .expedidos-faturados-conteudo {
    display: grid;
    grid-template-columns: 48.5% 48%;
    grid-template-rows: repeat(6, auto);
    grid-column-gap: 20px;
  }

  .unidade { grid-area: 1 / 1 / 2 / 3; }
  .representante { grid-area: 2 / 1 / 3 / 3; }
  .cliente { grid-area: 3 / 1 / 4 / 3; }
  .codigo-nome-produto { grid-area: 4 / 1 / 5 / 2; }
  .nome-produtoNovo { grid-area: 4 / 2 / 5 / 3; }
  .periodo { grid-area: 5 / 1 / 6 / 3; }
  .parametros { grid-area: 6 / 1 / 7 / 3; }

  .buscar-button-filtro {
    display: none;
  }
}

@media (min-width: 801px) {
.expedidos-faturados-conteudo {
  grid-template-columns: 48,5% 48%;
  grid-template-rows: repeat(5, auto);
  margin: 20px 20px 0 20px;
}
.unidade { grid-area: 1 / 1 / 2 / 3; }
.representante { grid-area: 2 / 1 / 3 / 3; }
.cliente { grid-area: 3 / 1 / 4 / 2; }
.codigo-nome-produto { grid-area: 3 / 2 / 4 / 3; }
.nome-produtoNovo { grid-area: 4 / 1 / 5 / 2; }
.periodo { grid-area: 4 / 2 / 5 / 3; }
.parametros { grid-area: 5 / 1 / 6 / 3; }
}

@media (min-width: 1025px) {
  .expedidos-faturados-conteudo {
    grid-template-columns: 49% minmax(6em, auto);
    grid-template-rows: repeat(4, auto);
  }
  .unidade { grid-area: 1 / 1 / 2 / 2; }
  .representante { grid-area: 1 / 2 / 2 / 3; }
  .cliente { grid-area: 2 / 1 / 3 / 2; }
  .codigo-nome-produto { grid-area: 2 / 2 / 3 / 3; }
  .nome-produtoNovo { grid-area: 3 / 1 / 4 / 2; }
  .periodo { grid-area: 3 / 2 / 4 / 3; }
  .parametros { grid-area: 4 / 1 / 5 / 2; }

}

@media (min-width: 1281px) {
  .expedidos-faturados-conteudo {
    grid-template-columns: repeat(3, minmax(6em, 40em));
    grid-template-rows: repeat(3, auto);
  }

  .unidade { grid-area: 1 / 1 / 2 / 2; }
  .representante { grid-area: 1 / 2 / 2 / 3; }
  .cliente { grid-area: 1 / 3 / 2 / 4; }
  .codigo-nome-produto { grid-area: 2 / 1 / 3 / 2; }
  .nome-produtoNovo { grid-area: 2 / 2 / 3 / 3; }
  .periodo { grid-area: 2 / 3 / 3 / 4; }
  .parametros { grid-area: 3 / 1 / 4 / 3; }
}

@media (min-width: 1500px) {

}

@media (min-width: 1900px) {
.expedidos-faturados-conteudo {
  grid-template-columns: repeat(4, minmax(6em, 40em));
  grid-template-rows: repeat(2, auto);
}
.unidade { grid-area: 1 / 1 / 2 / 2; }
.representante { grid-area: 1 / 2 / 2 / 3; }
.cliente { grid-area: 1 / 3 / 2 / 4; }
.codigo-nome-produto { grid-area: 1 / 4 / 2 / 5; }
.nome-produtoNovo { grid-area: 2 / 1 / 3 / 2; }
.periodo { grid-area: 2 / 2 / 3 / 3; }
.parametros { grid-area: 2 / 3 / 3 / 4; }
}
</style>